import React, { Component } from 'react';
import { VictoryChart, VictoryAxis, VictoryArea, VictoryPortal, VictoryLabel, VictoryScatter,
         VictoryVoronoiContainer, VictoryTooltip } from 'victory';
import { humanizeTimeSpan } from '../../../../../utilities/dateTime';

export class ByHourPrayingTimeDistribution extends Component{
  get scatterData() {
    return [
      { x: this.props.data[0].x, y: this.scatterPositionY },
      { x: this.props.data[12].x, y: this.scatterPositionY },
      { x: this.props.data[23].x, y: this.scatterPositionY }
    ]
  }

  get scatterPositionY() {
    return Math.max(...this.props.data.map((item) => item.y));
  }

  svgMoon(x, y) {
    return <text x={x - 6} y={y - 10} style={{fontFamily: 'anticon', stroke: '#c0c5c6'}}>&#xe90b;</text>;
  }

  svgSun(x, y) {
    return <text x={x - 6} y={y - 10} style={{fontFamily: 'anticon', stroke: '#c0c5c6'}}>&#xe912;</text>;
  }

  timeLabelText(tick) {
    const tickValue = tick.tz(this.props.timezone).format('hh A');

    switch(tickValue) {
      case '12 AM':
        return `MIDNIGHT\n${tickValue}`;
      case '12 PM':
        return `AFTERNOON\n${tickValue}`;
      default:
        return '';
    }
  }

  scatterDataComponent = ({datum, data, x, y}) => datum.x === data[1].x ? this.svgSun(x, y) : this.svgMoon(x, y);

  render() {
    return (
      this.props.data && this.props.data.some(item => item.y > 0) &&
      <div className="chart-container">
        <VictoryChart style={{ parent: { backgroundColor: '#f0f7f8' } }}
                      padding={{ top: 40, right: 50, bottom: 40, left: 50 }}
                      containerComponent={<VictoryVoronoiContainer/>}>
          <VictoryArea data={this.props.data} style={{data: { stroke: '#37e3ba', fill: '#b3ebe0', strokeWidth: 3 }}}
                       labels={this.props.pointTooltip}
                       labelComponent={ <VictoryTooltip style={{ fontSize: 14 }}/> }/>
          <VictoryAxis tickValues={[this.props.data[0].x, this.props.data[12].x, this.props.data[23].x]}
                       tickLabelComponent={<VictoryLabel textAnchor="start"/>}
                       tickFormat={(tick) => this.timeLabelText(tick) }
                       style={{axis: { stroke: 'transparent'}, grid:{ stroke: '#c0c5c6', strokeDasharray: 5}, tickLabels: { fill: '#c0c5c6', fontSize: 11 }}}/>
          <VictoryAxis dependentAxis tickValues={[0, this.scatterPositionY]}
                       tickFormat={(tick) => humanizeTimeSpan(tick)}
                       tickLabelComponent={<VictoryLabel renderInPortal/>}
                       style={{axis: { stroke: 'transparent'}, tickLabels: { fill: '#7c7f7f', fontSize: 11 }}}/>
          <VictoryScatter data={this.scatterData} dataComponent={<this.scatterDataComponent />} />
        </VictoryChart>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/charts/byHourPrayingTimeDistribution.js